import React from 'react';
import { TextBox, Switch, DatePicker, EmailBox, MaskedBox, PercentageBox, CheckBox } from 'fw/forms';
import { Label } from 'fw/components';
import { ReviewUpload } from 'areas/shared/components';
import { Row, Col, FormGroup, Button, Tooltip, Glyphicon } from 'react-bootstrap';
import { GenderCombo, ServiceBranchCombo, EthnicityCombo, PhoneBox, DocumentUpload } from 'areas/shared/controls';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Modals from 'fw/globals/Modals';
import API from 'fw/system/API';
import Moment from 'moment';
import { TooltipCode } from 'areas/shared/consts';
import DateColor from 'areas/admin/shared/DateColor';

class VeteranOwnerInfoItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = props => {
        return {
            veteranOwnerList: props.veteranOwnerList,
            isRenewal: props.isRenewal,
            formSF180StorageToken: props.formSF180StorageToken,
            formSF180fileName: props.formSF180fileName,
            tooltips: props.tooltips
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.veteranOwnerList instanceof Array) {
            this.setState({
                veteranOwnerList: nextProps.veteranOwnerList
            });
        }
    }

    handleOwnerResumeUploadChange = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.ownerResume = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleNonVeteranContributionsUploadChange = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.nonVeteranContributionsStorageToken = value.storageToken;
        item.nonVeteranContributionsFileName = value.fileName;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleSF180UploadChange = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.sF180 = value;

        if (value == null)
            item.sF180Confirmation = false;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleConfirmF180 = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.sF180Confirmation = value;
        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleCitizenshipProofUploadChange = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.citizenshipProof = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleBenefitVerificationLetterUploadChange = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.benefitVerificationLetter = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onDeleteVeteranOwner(index) {
        let me = this;
        Modals.confirm(
            "You are about to Delete this Owner. This Owner will no longer be linked to this company if you proceed. <br /><br />" +
            "If you wish to retain this Owner, please select 'No', and you will be returned to the previous screen. <br /><br />" +
            "If you wish to remove this Owner, please select 'Yes'.",
            function () {
                me.props.onDeleteVeteranOwner(index);
            }
        );
    }

    onUpdateAddVeteranOwner = (index, value) => {
        var item = this.state.veteranOwnerList[index];
        item.description = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onDateBlur = (index, value, controlName) => {
        if (value === "")
            return;
            
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);

        if (!date.isValid())
        {
            var item = this.state.veteranOwnerList[index];
            item[controlName] = "";
            this.refs[`${controlName}_${index}`].setValue("");
            this.props.onUpdateVeteranOwnerList(index, item);
        }
    }

    onChange = (index, value, controlName) => {
        var item = this.state.veteranOwnerList[index];
        
        if (item[controlName] === value)
            return;
            
        item[controlName] = value;

        if (controlName === 'isOwnerVeteran')
            this.checkBlankIsOwnerFields(item);
        if (controlName === 'veteranServiceConnectedDisabled')
            this.checkBlankDisabledUpload(item);

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    checkBlankDisabledUpload = (item) => {
        if (!item.veteranServiceConnectedDisabled) {
            item.benefitVerificationLetterStorageToken = null;
            item.benefitVerificationLetterFileName = null;
        }
    }

    checkBlankIsOwnerFields = (item) => {
        if (!item.isOwnerVeteran) {
            item.serviceBranchId = null;
            item.sF180SentDate = null;
            item.birthday = null;
            item.sF180Confirmation = false;
            item.veteranServiceConnectedDisabled = false;
            item.sF180StorageToken = null;
            item.sF180FileName = null;
            item.citizenshipProofStorageToken = null;
            item.citizenshipProofFileName = null;
            item.benefitVerificationLetterStorageToken = null;
            item.benefitVerificationLetterFileName = null;
        }
        else {
            item.nonVeteranContributionsStorageToken = null;
            item.nonVeteranContributionsFileName = null;
        }
    }

    onChangeDropdown = (index, value, controlName) => {
        var item = this.state.veteranOwnerList[index];
        item[controlName] = value.value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    downloadSF180 = () => {
        new API().download({
            storageToken: this.state.formSF180StorageToken,
            fileName: this.state.formSF180fileName
        });
    };

    addEmptyPhone = (index) => {
        var item = this.state.veteranOwnerList[index];

        item.phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -Math.abs(Date.now() | 0)
        });

        return item;
    }

    handleAddPhone = (index) => {
        var item = this.addEmptyPhone(index);
        this.props.onUpdateVeteranOwnerList(index, item);
    }

    handleRemovePhone = (index, phoneIndex) => {
        var item = this.state.veteranOwnerList[index];

        item.phones[phoneIndex].number = "";
        item.phones.splice(phoneIndex, 1);

        this.props.onUpdateVeteranOwnerList(index, item);
    }

    handlePhoneChange = (value, index, phoneIndex) => {
        var item = this.state.veteranOwnerList[index];

        item.phones[phoneIndex] = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    }

    renderPhones = (index) => {
        var me = this;
        if (this.state.veteranOwnerList[index].phones.length === 0)
            this.addEmptyPhone(index);

        return this.state.veteranOwnerList[index].phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    disabled={me.props.disabled}
                    required
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, index, i)}
                    ref={`phone_${i}`} />
                {(!me.props.disabled && i > 0) ?
                    <Button
                        bsStyle="link"
                        title="Remove Phone"
                        onClick={() => this.handleRemovePhone(index, i)}><FontAwesomeIcon icon={faTimes} /></Button>
                    : null}
            </div>
        );
    }

    register = (_form) => {
        
        if (this.props.skipValidations === false && _form) {
            for (var ref in this.refs) {
                _form.register(this.refs[ref]);
            }
        }
    }

    setTip = (property) => {
        const tooltip = this.props.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.text : null
    }

    render() {

        let me = this;
        let rows = this.state.veteranOwnerList.map(function (item, index) {
            item.provideOwnerLoginPermission = item.provideOwnerLoginPermission == null ? false : item.provideOwnerLoginPermission;
            item.isOwnerVeteran = item.isOwnerVeteran == null ? false : item.isOwnerVeteran;
        
            let dependentValues = { 
                certificationKey : item.certificationKey,
                dD214Warning : item.dD214Warning 
            };

            let veteranReviewDisabled = me.state.isRenewal && !item.fromRenewal;

            return (
                <FormGroup key={item.veteranOwnerId}>
                    <Row>
                        <Col md={5}>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor='ownerSSN' tip={me.setTip(TooltipCode.VETERAN.OWNERSSN)} required>
                                            Owner SSN
                                        </Label>
                                        <MaskedBox
                                            disabled={me.props.disabled}
                                            required
                                            name='ownerSSN'
                                            placeholder='Owner SSN'
                                            mask='999-99-9999'
                                            alwaysShowMask={false}
                                            maskChar=''
                                            value={item.ownerSSN}
                                            onChange={e => me.onChange(index, e, 'ownerSSN')}
                                            ref={`ownerSSN_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                                { item.isOwnerVeteran ?
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label htmlFor='veteranStatus'>Veteran Status</Label>
                                            <DateColor 
                                                value={item.dD214Status}
                                                dependentValues={dependentValues}
                                                borderStyle="solid"/>
                                        </FormGroup>
                                    </Col>
                                : null}
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label htmlFor='firstName' tip={me.setTip(TooltipCode.VETERAN.FIRSTNAME)} required>
                                            First Name
                                        </Label>
                                        <TextBox
                                            disabled={me.props.disabled}
                                            required
                                            name='firstName'
                                            placeholder="First Name"
                                            maxLength={40}
                                            value={item.firstName}
                                            onChange={e => me.onChange(index, e, 'firstName')}
                                            ref={`firstName_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor='lastName' tip={me.setTip(TooltipCode.VETERAN.LASTNAME)} required>
                                            Last Name
                                        </Label>
                                        <TextBox
                                            disabled={me.props.disabled}
                                            required
                                            name='lastName'
                                            placeholder="Last Name"
                                            maxLength={40}
                                            value={item.lastName}
                                            onChange={e => me.onChange(index, e, 'lastName')}
                                            ref={`lastName_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor='title' tip={me.setTip(TooltipCode.VETERAN.TITLE)} required>
                                            Title
                                        </Label>
                                        <TextBox
                                            disabled={me.props.disabled}
                                            required
                                            name='title'
                                            placeholder="Title"
                                            maxLength={25}
                                            value={item.title}
                                            onChange={e => me.onChange(index, e, 'title')}
                                            ref={`title_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor='birthDate' tip={me.setTip(TooltipCode.VETERAN.DATEOFBIRTH)} required>Date of Birth</Label>
                                        <DatePicker
                                            disabled={me.props.disabled}
                                            required
                                            placeholder='Select Date'
                                            managed={true}
                                            onBlur={e => me.onDateBlur(index, e, 'birthday')}
                                            isValidDate={(currentDate) => { return currentDate.isBefore(Moment()); }}
                                            value={item.birthday}
                                            onFieldChange={e => me.onChange(index, e, 'birthday')}
                                            showTime={false}
                                            ref={`birthday_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor='genderCode' tip={me.setTip(TooltipCode.VETERAN.GENDERCODE)} required>Gender</Label>
                                        <GenderCombo
                                            disabled={me.props.disabled}
                                            required
                                            placeholder="Gender"
                                            name='genderCode'
                                            value={item.genderCode}
                                            onChange={e => me.onChangeDropdown(index, e, 'genderCode')}
                                            ref={`genderCode_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label htmlFor='ethnicityId' tip={me.setTip(TooltipCode.VETERAN.ETHNICITY)} required>Ethnicity</Label>
                                        <EthnicityCombo
                                            disabled={me.props.disabled}
                                            required
                                            name='ethnicityId'
                                            placeholder="Ethnicity"
                                            value={item.ethnicityId}
                                            onChange={e => me.onChangeDropdown(index, e, 'ethnicityId')}
                                            ref={`ethnicityId_${index}`}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label htmlFor='email' tip={me.setTip(TooltipCode.VETERAN.EMAIL)} required>
                                            Email
                                        </Label>
                                        <EmailBox
                                            disabled={me.props.disabled}
                                            required
                                            name='email'
                                            placeholder='Email'
                                            value={item.email}
                                            onChange={e => me.onChange(index, e, 'email')}
                                            ref={`email_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor='businessHeldPercent' tip={me.setTip(TooltipCode.VETERAN.COMPANYHELD)} required>Percent of Company Held</Label>
                                        <PercentageBox
                                            disabled={me.props.disabled}
                                            required
                                            managed={true}
                                            placeholder="% Held"
                                            name='businessHeldPercent'
                                            value={item.businessHeldPercent}
                                            onFieldChange={e => me.onChange(index, e, 'businessHeldPercent')}
                                            precision={2}
                                            style={{ width: '80px' }}
                                            maxLength='6'
                                            ref={`businessHeldPercent_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label required htmlFor="phones" tip={me.setTip(TooltipCode.VETERAN.PHONENUMBER)} >Phone Number(s)</Label>
                                        {me.renderPhones(index)}
                                    </FormGroup>
                                    {(!me.props.disabled && me.state.veteranOwnerList[index].phones.length < 5) &&
                                        <Button bsStyle="default" bsSize="xsmall" className="pull-right" onClick={() => me.handleAddPhone(index)}>Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col md={1}></Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label tip={me.setTip(TooltipCode.VETERAN.OWNERRESUME)} required>Owner Resume</Label>
                                <ReviewUpload
                                    reviewUpload={item.ownerResume}
                                    reviewDisabled={veteranReviewDisabled}
                                    formatInline={false}
                                    // config={UploadsConfig}
                                    onChange={formUpload => me.handleOwnerResumeUploadChange(index, formUpload)}
                                    notApplicableAvailable={false}
                                    wrapFileNameLength={30}
                                    queueTypeCode={me.props.queueTypeCode}
                                    disabled={me.props.disabled}
                                    required
                                    ref={`ownerResume_${index}`}
                                />
                            </FormGroup>
                            {item.order > 0 ? (
                                <FormGroup>
                                    <Label htmlFor='isOwnerVeteran' tip={me.setTip(TooltipCode.VETERAN.OWNERVETERAN)}>Is this Owner a Veteran?</Label>
                                    <Switch
                                        disabled={me.props.disabled}
                                        name='isOwnerVeteran'
                                        labelLeft='No'
                                        labelRight='Yes'
                                        bsStyle='primary'
                                        value={item.isOwnerVeteran}
                                        onChange={e => me.onChange(index, e, 'isOwnerVeteran')}
                                    />
                                </FormGroup>
                            ) : null}
                            {index > 0 && !item.isOwnerVeteran ? (
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.VETERAN.NONVETERANCONTRIB)} required>Non-Veteran Contributions</Label>
                                    <DocumentUpload
                                        disabled={me.props.disabled}
                                        required
                                        storageToken={item.nonVeteranContributionsStorageToken}
                                        fileName={item.nonVeteranContributionsFileName}
                                        onChange={e => me.handleNonVeteranContributionsUploadChange(index, e)}
                                        ref={`nonVeteranContributions_${index}`}
                                    />
                                </FormGroup>
                            ) : null}
                            {item.isOwnerVeteran || item.order === 0 ? (
                                <React.Fragment>
                                    <FormGroup>
                                        <Label htmlFor='serviceBranchId' tip={me.setTip(TooltipCode.VETERAN.SERVICEBRANCH)} required>
                                            Branch of Service
                                        </Label>
                                        <ServiceBranchCombo
                                            disabled={me.props.disabled}
                                            required
                                            name='serviceBranchId'
                                            placeholder="Branch of Service"
                                            value={item.serviceBranchId}
                                            onChange={e => me.onChangeDropdown(index, e, 'serviceBranchId')}
                                            ref={`serviceBranchId_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label tip={me.setTip(TooltipCode.VETERAN.SF180UPLOAD)} required>SF180 Upload</Label>
                                        <Button bsStyle='default' bsSize='small' onClick={() => me.downloadSF180()} style={{ marginLeft: 10 }}>
                                            <FontAwesomeIcon icon={faExclamationTriangle} size='lg' color="orange" />
                                            &nbsp;&nbsp;Click here to download SF180 Form
                                            </Button>
                                        {me.setTip(TooltipCode.VETERAN.SF180FORM) && <Tooltip tip={me.setTip(TooltipCode.VETERAN.SF180FORM)} />}
                                        <ReviewUpload
                                            reviewUpload={item.sF180}
                                            reviewDisabled={veteranReviewDisabled}
                                            formatInline={false}
                                            // config={UploadsConfig}
                                            notApplicableAvailable={false}
                                            wrapFileNameLength={30}
                                            queueTypeCode={me.props.queueTypeCode}
                                            disabled={me.props.disabled}
                                            required
                                            onChange={formUpload => me.handleSF180UploadChange(index, formUpload)}
                                            ref={`sF180_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor='sF180SentDate' tip={me.setTip(TooltipCode.VETERAN.SF180SENTDATE)} required>
                                            Date SF180 was sent via postal mail to Custodian(s)
                                        </Label>
                                        <DatePicker
                                            disabled={me.props.disabled}
                                            required
                                            placeholder="Sent date"
                                            managed={true}
                                            onBlur={e => me.onDateBlur(index, e, 'sF180SentDate')}
                                            isValidDate={(currentDate) => { return currentDate.isBefore(Moment()); }}
                                            value={item.sF180SentDate}
                                            onFieldChange={e => me.onChange(index, e, 'sF180SentDate')}
                                            showTime={false}
                                            className='dpThin'
                                            ref={`sF180SentDate_${index}`}
                                        />
                                        <CheckBox
                                            inline
                                            value={item.sF180Confirmation}
                                            name='sF180Confirmation'
                                            disabled={(item.sF180.upload !== undefined && item.sF180.upload.storageToken ? false : true) || me.props.disabled}
                                            label='I confirm that I have carefully reviewed, signed, and sent the original NVBDC SF180 Request Form to the appropriate military records location'
                                            onChange={e => me.handleConfirmF180(index, e)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label tip={me.setTip(TooltipCode.VETERAN.PROOFCITIZENSHIP)} required>Proof of U.S. Citizenship Upload</Label>
                                        <ReviewUpload
                                            reviewUpload={item.citizenshipProof}
                                            reviewDisabled={veteranReviewDisabled && !item.citizenshipProofMissingFromOriginalApp}
                                            formatInline={false}
                                            // config={UploadsConfig}
                                            notApplicableAvailable={false}
                                            wrapFileNameLength={30}
                                            queueTypeCode={me.props.queueTypeCode}
                                            disabled={me.props.disabled}
                                            required
                                            onChange={formUpload => me.handleCitizenshipProofUploadChange(index, formUpload)}
                                            ref={`citizenshipProof_${index}`}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor='veteranServiceConnectedDisabled' tip={me.setTip(TooltipCode.VETERAN.VETERANSERVICEDISABLED)}>Does the Veteran have a Service Connected Disability?</Label>
                                        <Switch
                                            disabled={me.props.disabled}
                                            name='veteranServiceConnectedDisabled'
                                            labelLeft='No'
                                            labelRight='Yes'
                                            bsStyle='primary'
                                            value={item.veteranServiceConnectedDisabled}
                                            onChange={e => me.onChange(index, e, 'veteranServiceConnectedDisabled')}
                                        />
                                    </FormGroup>
                                    {item.veteranServiceConnectedDisabled ? (
                                        <FormGroup>
                                            <Label tip={me.setTip(TooltipCode.VETERAN.BENEFITVETLETTER)}>
                                                Benefit Verification Letter from EBenefits or VA - <font style={{ color: "red" }}>Do not Upload CVE Certificate</font>
                                                &nbsp;<span class="required-indicator">*</span>
                                            </Label>
                                            <ReviewUpload
                                                reviewUpload={item.benefitVerificationLetter}
                                                formatInline={false}
                                                // config={UploadsConfig}
                                                notApplicableAvailable={false}
                                                wrapFileNameLength={30}
                                                queueTypeCode={me.props.queueTypeCode}
                                                disabled={me.props.disabled}
                                                required
                                                onChange={formUpload => me.handleBenefitVerificationLetterUploadChange(index, formUpload)}
                                                ref={`benefitVerificationLetter_${index}`}
                                            />
                                        </FormGroup>
                                    ) : null}
                                </React.Fragment>
                            ) : null}
                        </Col>
                    </Row>
                    {!me.props.disabled && <Row>
                        <Col md={6}>
                            <FormGroup>
                                {index === me.state.veteranOwnerList.length - 1 ? (
                                    <Button onClick={() => me.props.addVeteranOwner(me.state.veteranOwnerList.length)} bsSize='xsmall'>
                                        Add another Owner
                                    </Button>
                                ) : null}
                                &nbsp;&nbsp;
                                {index > 0 ? (
                                    <Button onClick={() => me.onDeleteVeteranOwner(index)} bsSize='xsmall'>
                                        Remove Owner
                                    </Button>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={12}>
                            <hr />
                        </Col>  
                    </Row>
                </FormGroup>
            );
        });

        return <React.Fragment>{rows}</React.Fragment>;
    }
}

export default VeteranOwnerInfoItem;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/veteranOwnerInfo/VeteranOwnerInfoItem.js